import { NiceBaseListIcons, NiceFilterGroupService } from "@recursyve/nice-data-filter-kit";

export enum FilterGroups {
    Properties = "properties",
    PropertyOwners = "property_owners",
    PumpingVisits = "pumping_visits",
    SystemChannels = "system_channels",
    PrimarySystemChannels = "primary_system_channels",
    AdvancedSystemChannels = "advanced_system_channels",
    Owners = "owners",
    MaintenanceContracts = "maintenance_contracts",
    MaintenanceVisits = "maintenance_visits",
    AnalysisSamples = "analysis_samples",
    SeptageMeasurementVisits = "septage_measurement_visits"
}

export class FilterGroupsService extends NiceFilterGroupService<FilterGroups> {
    constructor() {
        super();
    }

    public getFilterGroupIconClass(group: FilterGroups): string | NiceBaseListIcons {
        switch (group) {
            case FilterGroups.Properties:
                return {
                    svgIcon: "streamline-regular:maps-pin-1"
                };
            case FilterGroups.PropertyOwners:
                return {
                    svgIcon: "streamline-regular:multiple-actions-key"
                };
            case FilterGroups.PumpingVisits:
                return {
                    svgIcon: "streamline-regular:gardening-watering-pipe"
                };
            case FilterGroups.SystemChannels:
                return {
                    svgIcon: "streamline-regular:archive-locker"
                };
            case FilterGroups.PrimarySystemChannels:
                return {
                    svgIcon: "streamline-regular:paginate-filter-1"
                };
            case FilterGroups.AdvancedSystemChannels:
                return {
                    svgIcon: "streamline-regular:paginate-filter-2"
                };
            case FilterGroups.Owners:
                return {
                    svgIcon: "streamline-regular:multi-neutral-2"
                };
            case FilterGroups.MaintenanceContracts:
                return {
                    svgIcon: "streamline-regular:common-file-text"
                };
            case FilterGroups.MaintenanceVisits:
                return {
                    svgIcon: "streamline-regular:tools-box"
                };
            case FilterGroups.AnalysisSamples:
                return {
                    svgIcon: "streamline-regular:lab-tube-experiment"
                };
            case FilterGroups.SeptageMeasurementVisits:
                return {
                    svgIcon: "streamline-regular:ruler"
                };
            default:
                return "";
        }
    }
}
